export function updateHunkLineEnds(options: {
  oldStart: number;
  newStart: number;
  oldConsumed: number;
  newConsumed: number;
}): { prevOldEnd: number; prevNewEnd: number } {
  const prevOldEnd =
    options.oldStart > 0 ? options.oldStart + options.oldConsumed - 1 : 0;
  const prevNewEnd =
    options.newStart > 0 ? options.newStart + options.newConsumed - 1 : 0;
  return { prevOldEnd, prevNewEnd };
}
